import { OPTIONS_INTEGRATION, PUBLIC_OPTIONS_INTEGRATION } from 'app-constants'
import { http } from 'hooks'

export function financialService() {
  function getBankSlips(contractId) {
    return http.get(
      `/v1/financials/bank-slips/pending?contractId=${contractId}`,
      OPTIONS_INTEGRATION
    )
  }

  function getPaidSlips(contractId, page, limit = 5) {
    return http.get(
      `/v1/financials/bank-slips/paid?limit=${limit}&page=${page}&contractId=${contractId}`,
      OPTIONS_INTEGRATION
    )
  }

  function getInvoices(contractId, page, limit = 5) {
    return http.get(
      `/v1/financials/invoices?limit=${limit}&page=${page}&contractId=${contractId}`,
      OPTIONS_INTEGRATION
    )
  }

  function getPaidBillDownloadLink(invoiceId) {
    const params = {
      invoiceId,
    }

    return http.get('/v1/financials/bank-slips/paid/link', {
      params,
      ...OPTIONS_INTEGRATION,
    })
  }

  function getNegotiationEligible(params) {
    return http.get('/v1/financials/negotiations/check-eligibility', {
      params,
      ...OPTIONS_INTEGRATION,
    })
  }

  function getNegotiationInvoices(params) {
    return http.get('/v1/financials/negotiations', {
      params,
      ...OPTIONS_INTEGRATION,
    })
  }

  function postConfirmationNegotiation(params) {
    return http.post('/v1/financials/negotiations/confirm', params, OPTIONS_INTEGRATION)
  }

  function generatePaymentLink(params) {
    return http.post('/v2/financials/payments/generate-link', params, OPTIONS_INTEGRATION)
  }

  function getFastBilletBankSlip(document) {
    return http.get('/v1/financials/bank-slips/pending/fast-access', {
      params: {
        cpf_cnpj: document,
      },
      ...PUBLIC_OPTIONS_INTEGRATION,
    })
  }

  function getObjections(params) {
    return http.get('/v1/financials/billing-dispute', {
      params,
      ...OPTIONS_INTEGRATION,
    })
  }

  function getRecurringPaymentLink(contractId) {
    return http.get('/v1/financials/recurring-payment/link', {
      params: {
        contractId,
      },
      ...OPTIONS_INTEGRATION,
    })
  }

  function getSydlePaymentLink(invoiceId, sessionId) {
    return http.post('/v1/financials/payments/link', { invoiceId, sessionId }, OPTIONS_INTEGRATION)
  }

  function getPaymentOptions(invoiceId) {
    return http.get(`/v1/financials/${invoiceId}/available-payment-methods`, {
      params: { invoiceId },
      ...OPTIONS_INTEGRATION,
    })
  }

  return {
    getBankSlips,
    getPaidSlips,
    getInvoices,
    getPaidBillDownloadLink,
    getNegotiationEligible,
    getNegotiationInvoices,
    postConfirmationNegotiation,
    generatePaymentLink,
    getFastBilletBankSlip,
    getObjections,
    getRecurringPaymentLink,
    getSydlePaymentLink,
    getPaymentOptions,
  }
}
